import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProfileDashboard } from '../components/ProfileDashboard';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useAuthStore } from '../store/authStore';

export function Dashboard() {
  const navigate = useNavigate();
  const { user, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    // Check auth state when component mounts
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    // Only redirect if we've finished checking auth and there's no user
    if (!isLoading && !user) {
      navigate('/');
    }
  }, [user, isLoading, navigate]);

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="animate-pulse">
            <div className="h-8 bg-gray-200 rounded w-1/4 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // Don't render anything if not authenticated
  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header 
        profile={user}
        onLogout={() => {
          useAuthStore.getState().signOut();
          navigate('/');
        }}
        onSettings={() => navigate('/settings')}
      />
      <div className="flex-grow">
        <ProfileDashboard 
          profile={user} 
          onNewProject={() => navigate('/new-project')} 
        />
      </div>
      <Footer />
    </div>
  );
}